import { forwardRef } from 'react';

export interface LogoProps
  extends Omit<
    React.SVGProps<SVGSVGElement>,
    'xmlns' | 'width' | 'height' | 'viewBox' | 'fill'
  > {
  /** Sets the `class` attribute. */
  className?: string | undefined;
  /** Sets the inverse logo colors. */
  inverse?: boolean | undefined;
}

const LogoSmall = forwardRef<SVGSVGElement, LogoProps>(
  ({ inverse = false, ...props }, forwardedRef) => {
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="45"
        height="45"
        viewBox="0 0 45 45"
        fill={inverse ? '#ffffff' : '#000000'}
        ref={forwardedRef}
        aria-label="Thrivent Logo"
      >
        <path
          d="M20.2302 3.64127C20.2302 1.63084 18.3599 0 16.3495 0C14.339 0 12.4702 1.63084 12.4702 3.64127V7.29131H20.2302V3.64127Z"
          fill="#A60536"
        />
        <path
          d="M23.8773 15.0484C25.8877 15.0484 27.5171 13.1781 27.5171 11.1676C27.5171 9.1572 25.8877 7.28693 23.8773 7.28693H12.4702V15.0484H23.8773Z"
          fill="#E30045"
        />
        <path
          d="M20.2302 15.0483H12.4702V28.5418C12.4702 32.5432 13.2786 35.4535 14.8953 37.2727C16.512 39.0918 19.4807 40.001 23.8014 40H27.1361V32.4225H24.5343C22.7959 32.4225 21.644 32.0789 21.0785 31.3917C20.5129 30.7046 20.2302 29.5122 20.2302 27.8147V15.0483Z"
          fill="#11181C"
        />
        <text x="30" y="40" fontSize="10" fill="black">
          ®
        </text>
      </svg>
    );
  },
);

LogoSmall.displayName = 'Logo';

export default LogoSmall;
